// Local Y-M-D for <input type="date">. toISOString() is UTC and can shift the
// calendar day in US timezones; getFullYear/getMonth/getDate stay on the
// browser's local day. Match Capture GoNoGoPanel dateInputValue / parseDateInput.
export function dateInputValue(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}
export function parseDateInput(value) {
    if (!value) return null;
    const [y, m, d] = value.split('-').map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
}
export function timestampToDateInput(ts) {
    if (!ts) return '';
    let d;
    if (typeof ts.toDate === 'function') {
        try {
            d = ts.toDate();
        } catch  {
            return '';
        }
    } else if (ts.seconds) {
        d = new Date(Number(ts.seconds) * 1000);
    }
    if (!d || Number.isNaN(d.getTime())) return '';
    return dateInputValue(d);
}
